import store from 'store';
import { GET_DRIVER_GUIDE } from 'store/actions/guide';

const Layout = () => import(/* webpackChunkName: "pages/container" */ 'layout');
const Error = () => import(/* webpackChunkName: "pages/views/error" */ 'views/Error');
const Base = () => import(/* webpackChunkName: "pages/views/base" */ 'views/Base');
const Legal = () => import(/* webpackChunkName: "pages/views/legal" */ 'views/Legal');

export default [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: ':carRegistration',
        component: Base,
        meta: { titleKey: 'home' },
        name: 'base',
        beforeEnter(to, from, next) {
          const { carRegistration } = to.params;
          store
            .dispatch(`guide/${GET_DRIVER_GUIDE}`, carRegistration)
            .then(() => next())
            .catch(() => next({ name: 'error', params: { GET_DRIVER_GUIDE } }));
        }
      },
      {
        path: 'legal/:type',
        component: Legal,
        name: 'legal',
        props: { whithoutLinksFooter: false },
        meta: { titleKey: 'legal' }
      },
      {
        path: 'error',
        name: 'error',
        component: Error,
        props: { type: 'error' },
        meta: { titleKey: 'error' }
      },
      {
        path: '*',
        name: '404',
        component: Error,
        props: { type: '404_es-ES' },
        meta: { titleKey: 'notFound' }
      }
    ]
  }
];
